import { loc } from "./numerals";

export const STATUSES = ["Pending", "In Progress", "Delayed", "Completed"];
export const PRIORITIES = ["High", "Medium", "Low"];

export const STATUS_STYLES = {
  Delayed: { row: "bg-red-50/70 border-l-4 border-l-red-500 hover:bg-red-50", badge: "bg-red-100 text-red-700 border border-red-200", bar: "#EF4444", dot: "#EF4444" },
  "In Progress": { row: "bg-amber-50/50 border-l-4 border-l-amber-500 hover:bg-amber-50", badge: "bg-amber-100 text-amber-800 border border-amber-200", bar: "#F59E0B", dot: "#F59E0B" },
  Completed: { row: "bg-emerald-50/40 border-l-4 border-l-emerald-500 hover:bg-emerald-50", badge: "bg-emerald-100 text-emerald-700 border border-emerald-200", bar: "#10B981", dot: "#10B981" },
  Pending: { row: "bg-slate-50/60 border-l-4 border-l-slate-400 hover:bg-slate-100", badge: "bg-slate-100 text-slate-600 border border-slate-200", bar: "#94A3B8", dot: "#94A3B8" },
};

export const PRIORITY_STYLES = {
  High: "bg-red-100 text-red-700 border border-red-200",
  Medium: "bg-blue-100 text-blue-700 border border-blue-200",
  Low: "bg-slate-100 text-slate-600 border border-slate-200",
};

export const MACHINE_STATUS = {
  active: { label: "Active", color: "#10B981", bg: "bg-emerald-100 text-emerald-700" },
  idle: { label: "Idle", color: "#F59E0B", bg: "bg-amber-100 text-amber-700" },
  downtime: { label: "Downtime", color: "#EF4444", bg: "bg-red-100 text-red-700" },
};

// Quantity formatting: weights (kg) always show 3 decimals; every other unit (pcs, m, L, sets…) is a whole number.
const KG_UNITS = new Set(["kg", "kgs", "kilogram", "kilograms"]);
export const isWeightUnit = (unit) => KG_UNITS.has(String(unit || "").trim().toLowerCase());
export function fmtQty(n, unit) {
  const v = Number(n || 0);
  if (isWeightUnit(unit)) return loc(v.toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
  return loc(Math.round(v).toLocaleString("en-IN", { maximumFractionDigits: 0 }));
}
export const qtyStep = (unit) => (isWeightUnit(unit) ? "0.001" : "1");

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  } catch {
    return "—";
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "—";
  }
}
